import useCollection from 'core/hooks/useCollection'

const useSupercases = (...args) => useCollection('supercases', ...args)
export default useSupercases
